export enum ErrorKey {
  Unauthorized = 'key_Unauthorized',
  UnauthorizedPatient = 'key_UnauthorizedPatient',
  UnauthorizedTherapist = 'key_UnauthorizedTherapist',
  Forbidden = 'key_Forbidden',
  TenantMissing = 'key_TenantMissing',
  PatientExists = 'key_patientExists',
  NoTherapistFound = 'key_noTherapistFound',
  TherapyIDMissing = 'key_TherapyIDMissing',
  TherapyNotFound = 'key_TherapyNotFound',
  DeletedSuccess = 'key_DeletedSuccess',
  WrongTherapy = 'key_WrongTherapy',
  PatientNotFound = 'key_PatientNotFound',
  FirstNameMissing = 'key_FirstNameMissing',
  LastNameMissing = 'key_LastNameMissing',
  EmailMissing = 'key_EmailMissing',
  PatientProfileCheck = 'key_PatientProfileCheck',
  NoProfileFound = 'key_NoProfileFound',
  InvalidAuth0AccountId = 'key_InvalidAuth0AccountId',
  OnBoardingFailed = 'key_OnBoardingFailed',
  PasswordResetEmailSent = 'key_PasswordResetEmailSent',
  AppointmentNotFound = 'key_AppointmentNotFound',
  DeleteAppointmentFailed = 'key_DeleteAppointmentFailed',
  DeleteAppointmentSuccess = 'key_DeleteAppointmentSuccess',
  InvalidInputs = 'key_InvalidInputs',
  TrainingNotFound = 'key_TrainingNotFound',
  DeleteTrainingFailed = 'key_DeleteTrainingFailed',
  DeleteTrainingSuccess = 'key_DeleteTrainingSuccess',
  NoMobileAccess = 'key_NoMobileAccess',
  InvalidPatientLogin = 'key_InvalidPatientLogin',
  InvalidCredentials = 'key_InvalidCredentials',
  TagNotFound = 'key_TagNotFound',
  NoAnswerFound = 'key_NoAnswerFound',
  NoQuestionFound = 'key_NoQuestionFound',
  RoomCodeNotFound = 'key_RoomCodeNotFound',
  RoomCodeChangeNotAllowed = 'key_RoomCodeChangeNotAllowed',
  RoomAlreadyFull = 'key_RoomAlreadyFull',
  RoomProvidePin = 'key_RoomProvidePin',
  RoomAlreadyParticipated = 'key_RoomAlreadyParticipated',
  RoomParticipationCancelled = 'key_RoomParticipationCancelled',
  RoomWrongPin = 'key_RoomWrongPin',
  RoomTrainerNotAllowed = 'key_RoomTrainerNotAllowed',
  RoomNoSessionFound = 'key_RoomNoSessionFound',
  NoActiveAppointment = 'key_NoActiveAppointment',
  OnlyP2PCallsAllowed = 'key_OnlyP2PCallsAllowed',
  TherapistNotAssignedToRoom = 'key_TherapistNotAssignedToRoom',
  PatientNotAssignedToAppointment = 'key_PatientNotAssignedToAppointment',
  InstantRoomNotAllowedOnMobile = 'key_InstantRoomNotAllowedOnMobile',
  ResetPatientPassword = 'key_ResetPatientPassword',
  LogoutSuccess = 'key_LogoutSuccess',
  TherapistMarkedAsTestUser = 'key_TherapistMarkedAsTestUser',
  AppointmentRescheduleFailed = 'key_AppointmentRescheduleFailed',
  AppointmentBookingFailed = 'key_AppointmentBookingFailed',
  AppointmentDeletedSuccessfully = 'key_AppointmentDeletedSuccessfully',
  DuplicateSpecialization = 'key_DuplicateSpecialization',
  NoPlanNameFound = 'key_NoPlanNameFound',
  TherapistNotFound = 'key_TherapistNotFound',
  OnSchedAPIFailed = 'key_OnSchedAPIFailed',
  NoTherapyFound = 'key_NoTherapyFound',
  VerificationCodeSent = 'key_VerificationCodeSent',
  Auth0APIError = 'key_Auth0APIError',
  CodeVerificationSuccessful = 'key_CodeVerificationSuccessful',
  InvalidInsuranceNo = 'key_InvalidInsuranceNo',
  TherapistPlanUpdatedSuccessful = 'key_TherapistPlanUpdatedSuccessful',
  TemplateDeletedSuccssful = 'key_TemplateDeletedSuccssful',
  WeekPassword = 'key_WeekPassword',
  ProfileDeletedSuccessfully = 'key_ProfileDeletedSuccessfully',
  InvalidRequest = 'key_InvalidRequest',
  WrongEmailOrVerificationCode = 'key_WrongEmailOrVerificationCode',
  PatientAlreadyVerified = 'key_PatientAlreadyVerified',
  TrainingTemplateSaved = 'key_TrainingTemplateSaved',
  PatientDeletedSuccess = 'key_PatientDeletedSuccess',
  OnBoardingAnswerSavedSuccessfully = 'key_OnBoardingAnswerSavedSuccessfully',
  NotFound = 'key_NotFound',
  ChatKeySavedSuccessfully = 'key_ChatKeySavedSuccessfully',
  TherapistPlanUpgradeError = 'key_TherapistPlanUpgradeError',
  PatientLimitReached = 'key_PatientLimitReached',
  FeatureNotAllowed = 'key_FeatureNotAllowed',
  PlanCanceled = 'key_PlanCanceled',
  NoActivePlanFound = 'key_NoActivePlanFound',
  PlanExpried = 'key_PlanExpried',
  InternalServerError = 'key_InternalServerError',
  InvalidAppointmentId = 'key_InvalidAppointmentId',
  NoTenantFound = 'key_NoTenantFound',
  AppointmentNotConfirmable = 'key_AppointmentNotConfirmable',
  AppointmentNotRejectable = 'key_AppointmentNotRejectable',
  AppointmentAlreadyStarted = 'key_AppointmentAlreadyStarted',
  AppointmentNotCancelable = 'key_AppointmentNotCancelable',
  AppointmentNotReschedulable = 'key_AppointmentNotReschedulable',
  InvalidPatientId = 'key_InvalidPatientId',
  CategoryIsUsedByTag = 'key_CategoryIsUsedByTag',
  TagIsUedByVideo = 'key_TagIsUedByVideo',
  TrainingPlanNotDraft = 'key_TrainingPlanNotDraft',
  CompletionConversationAlreadySet = 'key_CompletionConversationAlreadySet',
  CompletionDocumentMissing = 'key_CompletionDocumentMissing',
  CompletionNotAllowed = 'key_CompletionNotAllowed',
  PatientAccessBlocked = 'key_PatientAccessBlocked',
  CancellationAlreadySet = 'key_CancellationAlreadySet',
  InvalidTrainingPlanStatusTransition = 'key_InvalidTrainingPlanStatusTransition',
  ActiveTrainingPlanAlreadyExists = 'key_ActiveTrainingPlanAlreadyExists',
}
